import { gql } from '@apollo/client'

export const SYNTHESIZE_SPEECH = gql`
  mutation synthesizeSpeech($chunkId: ID!, $text: String!) {
    synthesizeSpeech(chunkId: $chunkId, text: $text) {
      chunkId
      audioBase64
      contentType
    }
  }
`
